import { InjectionToken } from "@angular/core";

import { FormErrorFormatterMap } from "./models";

export const FORM_ERROR_FORMATTER_MAP = new InjectionToken(
  "FORM_ERROR_FORMATTER_MAP"
);

export const DEFAULT_FORM_ERROR_FORMATTERS: FormErrorFormatterMap = {
  alphanumeric: (label) => `${label} can only contain letters and numbers`,
  alphanumericWithSpaces: (label) =>
    `${label} can only contain letters, numbers, and spaces`,
  isInt: (label: string) => `${label} must be an integer`,
  min: (label: string, details: { requiredValue: number }) =>
    `${label} must be greater than or equal to ${details.requiredValue}`,
  max: (label: string, details: { requiredValue: number }) =>
    `${label} must be less than or equal to ${details.requiredValue}`,
  minLength: (label: string, details: { requiredLength: number }) =>
    `${label} must be at least ${details.requiredLength} character${
      details.requiredLength !== 1 ? "s" : ""
    }`,
  minSize: (label: string, details: { requiredSize: number }) =>
    `Must have at least ${details.requiredSize} ${
      label != null ? label.toLowerCase() : ""
    }${label != null && details.requiredSize !== 1 ? "s" : ""}`,
  maxSize: (label: string, details: { requiredSize: number }) =>
    `Must have no more than ${details.requiredSize} ${
      label != null ? label.toLowerCase() : ""
      }`,
  maxLength: (label: string, details: { requiredLength: number }) =>
    `${label} must be ${details.requiredLength} characters or less`,
  required: (label: string) => `${label} is required`,
  dateOutOfRange: (label: string, details: { range: number }) =>
    `${label} cannot be more than ${details.range} days before or after today`,
  isEmail: (label: string) =>
    `${label} field does not contain a valid email address`,
  /**
   * `nested` and `each` return undefined by default because they are used
   * for nested errors in @lchemy/model/validation RuleCheckResult maps.
   * If needed, overwrite them using the injection token provided above.
   */
  model: () => undefined,
  nested: () => undefined,
  each: () => undefined
};
